import {
  CheckCircleIcon,
  MinusCircleIcon,
  PlayIcon,
} from "@heroicons/react/outline";
import { MouseEvent, useMemo } from "react";

import { LISCase } from "pwapi";

import { useAppSelector } from "app/hooks";

import ContextMenu from "./ContextMenu";

const CaseWorkHierarchy = ({
  pathCase,
  onClickFilter,
}: {
  pathCase: LISCase;
  onClickFilter: (
    event: MouseEvent<HTMLElement>,
    type: "Order" | "Work" | "Task" | "Block",
    id: number
  ) => void;
}) => {
  const sortedWorkProcesses = useMemo(
    () =>
      [...(pathCase?.work_processes || [])].sort(
        (a, b) => (a.id || 0) - (b.id || 0)
      ),
    [pathCase?.work_processes]
  );

  const labStains = useAppSelector((state) => state.labStains);
  const stains = useAppSelector((state) => state.stains);

  return (
    <div className="CaseWorkHierarchy hierarchy-items">
      {sortedWorkProcesses.map((work) => (
        <div key={work.id} className="hierarchy-item">
          <h3>
            {work.order ? (
              <>
                {/* TODO: Add Tooltips here with exact timestamps for Order.completed_at */}
                {!!work.order.completed_at ? (
                  <CheckCircleIcon height="1em" className="completed" />
                ) : (
                  <PlayIcon height="1em" className="in-progress" />
                )}
                {" Order "}
                <a
                  className="header-value"
                  href={`#Order-${work.order.id}`}
                  id={`Order-${work.order.id}`}
                  onClick={(event: MouseEvent<HTMLElement>) =>
                    onClickFilter(event, "Order", work.order?.id || 0)
                  }
                >
                  {work.order.id}
                </a>
                <ContextMenu
                  caseId={pathCase.id || 0}
                  type="Order"
                  id={work.order.id || 0}
                />
                <code> {work.order.type.toUpperCase()} </code>
                {work.order.type === "stain" && (
                  <>
                    {"Block "}
                    <a
                      className="header-value"
                      href={`#Block-${work.order?.block_id}`}
                      id={`Order-${work.order.id}`}
                      onClick={(event: MouseEvent<HTMLElement>) =>
                        onClickFilter(event, "Block", work.order?.block_id || 0)
                      }
                    >
                      {pathCase.specimens.find(
                        (s) =>
                          s.id ===
                          pathCase.blocks.find(
                            (b) => b.id === work.order?.block_id
                          )?.specimen_id
                      )?.name || ""}
                      {pathCase.blocks.find(
                        (b) => b.id === work.order?.block_id
                      )?.name || ""}
                    </a>

                    {!!work.order?.lab_stain_id && (
                      <code>
                        {" "}
                        {
                          stains[
                            labStains[work.order?.lab_stain_id || 0]
                              ?.stain_id || 0
                          ]?.abbreviation
                        }{" "}
                      </code>
                    )}
                  </>
                )}
                {work.order.type === "rescan" && (
                  <> Slide {work.order.slide_id}</>
                )}
              </>
            ) : (
              "ROUTINE"
            )}
            {" - "}
            {/* TODO: Add Tooltips here with exact timestamps for WorkProcess.completed_at */}
            {!!work.completed_at ? (
              <CheckCircleIcon height="1em" className="completed" />
            ) : (
              <PlayIcon height="1em" className="in-progress" />
            )}
            {" Work "}
            <a
              className="header-value"
              href={`#Work-${work.id}`}
              id={`Work-${work.id}`}
              onClick={(event: MouseEvent<HTMLElement>) =>
                onClickFilter(event, "Work", work.id || 0)
              }
            >
              {work.id}
            </a>
            <ContextMenu
              caseId={pathCase.id || 0}
              type="Work"
              id={work.id || 0}
            />
          </h3>
          <div className="TaskHierarchy hierarchy-items">
            {work.tasks.map((task) => (
              <div key={task.id} className="hierarchy-item">
                {/* TODO: Add Tooltips here with exact timestamps for started_at and completed_at */}
                {!!task.completed_at ? (
                  <CheckCircleIcon height="1em" className="completed" />
                ) : !!task.started_at ? (
                  <PlayIcon height="1em" className="in-progress" />
                ) : (
                  <MinusCircleIcon height="1em" className="not-started" />
                )}
                {" Task "}
                <a
                  className="header-value"
                  href={`#Task-${task.id}`}
                  id={`Task-${task.id}`}
                  onClick={(event: MouseEvent<HTMLElement>) =>
                    onClickFilter(event, "Task", task.id || 0)
                  }
                >
                  {task.id}
                </a>{" "}
                {task.type.toUpperCase()}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CaseWorkHierarchy;
